import Translation from '../Translation/cont/Translation'

const TmdbExternalLink = ({ tmdbId, className }) => {
    if (!tmdbId) return null

    return (
        <a
            className={className}
            href={`https://www.themoviedb.org/movie/${tmdbId}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            <Translation id="tmdb_label" /> ↗
        </a>
    )
}

export default TmdbExternalLink
